//image representing no selection
import none from '../assets/Shared/none.png'

import bg from '../assets/Style/background_image.jpeg'
import armor from '../assets/Style/armor_button.png'
import weapons from '../assets/Style/weapons_button.png'
import login from '../assets/Style/login_button.png'
import play from '../assets/Style/play_button.png'
import reroll from '../assets/Style/reroll_button.png'
import home from '../assets/Style/home_button.png'
import title from '../assets/Style/title_image.png'
import register from '../assets/Style/register_butt.png'
import logout from '../assets/Style/logout_button.png'

import selall from '../assets/Style/selall_button.png'
import deselall from '../assets/Style/deselall_img.png'
import confirm from '../assets/Style/confirm_button.png'

//subclasses
import arc from '../assets/Shared/arc.png';
import grape from '../assets/Shared/void.png';
import solar from '../assets/Shared/solar.png';
import stasis from '../assets/Shared/stasis.png';
import strand from '../assets/Shared/strand.png';

//classes
import hunter from '../assets/Hunter/hunter.png';
import warlock from '../assets/Warlock/warlock.png';
import titan from '../assets/Titan/titan.png';

//void sharables
//grenades
import magnetic_grenade from '../assets/Shared/Grenades/Void/magnetic_grenade.jpg';
import axion_bolt_grenade from '../assets/Shared/Grenades/Void/axion_bolt_grenade.jpg';
import scatter_grenade from '../assets/Shared/Grenades/Void/scatter_grenade.jpg';
import suppressor_grenade from '../assets/Shared/Grenades/Void/supressor_grenade.jpg';
import void_spike_grenade from '../assets/Shared/Grenades/Void/void_spike_grenade.jpg';
import void_wall_grenade from '../assets/Shared/Grenades/Void/void_wall_grenade.jpg';
import vortex_grenade from '../assets/Shared/Grenades/Void/vortex_grenade.jpg';
//fragments
import echo_of_cessation from '../assets/Shared/Fragments/Void/echo_of_cessation.jpg';
import echo_of_dialation from '../assets/Shared/Fragments/Void/echo_of_dialation.jpg';
import echo_of_domineering from '../assets/Shared/Fragments/Void/echo_of_domineering.jpg';
import echo_of_exchange from '../assets/Shared/Fragments/Void/echo_of_exchange.jpg';
import echo_of_expulsion from '../assets/Shared/Fragments/Void/echo_of_expulsion.jpg';
import echo_of_harvest from '../assets/Shared/Fragments/Void/echo_of_harvest.jpg';
import echo_of_instability from '../assets/Shared/Fragments/Void/echo_of_instability.jpg';
import echo_of_leeching from '../assets/Shared/Fragments/Void/echo_of_leeching.jpg';
import echo_of_obscurity from '../assets/Shared/Fragments/Void/echo_of_obscurity.jpg';
import echo_of_persistance from '../assets/Shared/Fragments/Void/echo_of_persistance.jpg';
import echo_of_provision from '../assets/Shared/Fragments/Void/echo_of_provision.jpg';
import echo_of_remnants from '../assets/Shared/Fragments/Void/echo_of_remnants.jpg';
import echo_of_reprisal from '../assets/Shared/Fragments/Void/echo_of_reprisal.jpg';
import echo_of_starvation from '../assets/Shared/Fragments/Void/echo_of_starvation.jpg';
import echo_of_undermining from '../assets/Shared/Fragments/Void/echo_of_undermining.jpg';
import echo_of_vigilance from '../assets/Shared/Fragments/Void/echo_of_vigilance.jpg';

//solar sharables
//grenades
import firebolt_grenade from '../assets/Shared/Grenades/Solar/firebolt_grenade.jpg';
import fusion_grenade from '../assets/Shared/Grenades/Solar/fusion_grenade.jpg';
import healing_grenade from '../assets/Shared/Grenades/Solar/healing_grenade.jpg';
import incindiary_grenade from '../assets/Shared/Grenades/Solar/incindiary_grenade.jpg';
import solar_grenade from '../assets/Shared/Grenades/Solar/solar_grenade.jpg';
import swarm_grenade from '../assets/Shared/Grenades/Solar/swarm_grenade.jpg';
import thermite_grenade from '../assets/Shared/Grenades/Solar/thermite_grenade.jpg';
import tripmine_grenade from '../assets/Shared/Grenades/Solar/tripmine_grenade.jpg';
//fragments
import ember_of_ashes from '../assets/Shared/Fragments/Solar/ember_of_ashes.jpg';
import ember_of_beams from '../assets/Shared/Fragments/Solar/ember_of_beams.jpg';
import ember_of_benevolence from '../assets/Shared/Fragments/Solar/ember_of_benevolence.jpg';
import ember_of_blistering from '../assets/Shared/Fragments/Solar/ember_of_blistering.jpg';
import ember_of_char from '../assets/Shared/Fragments/Solar/ember_of_char.jpg';
import ember_of_combustion from '../assets/Shared/Fragments/Solar/ember_of_combustion.jpg';
import ember_of_empyrian from '../assets/Shared/Fragments/Solar/ember_of_empyrian.jpg';
import ember_of_eruption from '../assets/Shared/Fragments/Solar/ember_of_eruption.jpg';
import ember_of_mercy from '../assets/Shared/Fragments/Solar/ember_of_mercy.jpg';
import ember_of_resolve from '../assets/Shared/Fragments/Solar/ember_of_resolve.jpg';
import ember_of_searing from '../assets/Shared/Fragments/Solar/ember_of_searing.jpg';
import ember_of_singeing from '../assets/Shared/Fragments/Solar/ember_of_singeing.jpg';
import ember_of_solace from '../assets/Shared/Fragments/Solar/ember_of_solace.jpg';
import ember_of_tempering from '../assets/Shared/Fragments/Solar/ember_of_tempering.jpg';
import ember_of_torches from '../assets/Shared/Fragments/Solar/ember_of_torches.jpg';
import ember_of_wonder from '../assets/Shared/Fragments/Solar/ember_of_wonder.jpg';

//arc sharables
//grenades
import arcbolt_grenade from '../assets/Shared/Grenades/Arc/arcbolt_grenade.jpg';
import flashbang_grenade from '../assets/Shared/Grenades/Arc/flashbang_grenade.jpg';
import flux_grenade from '../assets/Shared/Grenades/Arc/flux_grenade.jpg';
import lightning_grenade from '../assets/Shared/Grenades/Arc/lightning_grenade.jpg';
import pulse_grenade from '../assets/Shared/Grenades/Arc/pulse_grenade.jpg';
import skip_grenade from '../assets/Shared/Grenades/Arc/skip_grenade.jpg';
import storm_grenade from '../assets/Shared/Grenades/Arc/storm_grenade.jpg';
//fragments
import spark_of_amplitude from '../assets/Shared/Fragments/Arc/spark_of_amplitude.jpg';
import spark_of_beacons from '../assets/Shared/Fragments/Arc/spark_of_beacons.jpg';
import spark_of_brilliance from '../assets/Shared/Fragments/Arc/spark_of_brilliance.jpg';
import spark_of_discharge from '../assets/Shared/Fragments/Arc/spark_of_discharge.jpg';
import spark_of_feedback from '../assets/Shared/Fragments/Arc/spark_of_feedback.jpg';
import spark_of_focus from '../assets/Shared/Fragments/Arc/spark_of_focus.jpg';
import spark_of_frequency from '../assets/Shared/Fragments/Arc/spark_of_frequency.jpg';
import spark_of_haste from '../assets/Shared/Fragments/Arc/spark_of_haste.jpg';
import spark_of_instinct from '../assets/Shared/Fragments/Arc/spark_of_instinct.jpg';
import spark_of_ions from '../assets/Shared/Fragments/Arc/spark_of_ions.jpg';
import spark_of_magnitude from '../assets/Shared/Fragments/Arc/spark_of_magnitude.jpg';
import spark_of_momentum from '../assets/Shared/Fragments/Arc/spark_of_momentum.jpg';
import spark_of_recharge from '../assets/Shared/Fragments/Arc/spark_of_recharge.jpg';
import spark_of_resistance from '../assets/Shared/Fragments/Arc/spark_of_resistance.jpg';
import spark_of_shock from '../assets/Shared/Fragments/Arc/spark_of_shock.jpg';
import spark_of_volts from '../assets/Shared/Fragments/Arc/spark_of_volts.jpg';

//stasis sharables
//grenades
import coldsnap_grenade from '../assets/Shared/Grenades/Stasis/coldsnap_grenade.png';
import duskfield_grenade from '../assets/Shared/Grenades/Stasis/duskfield_grenade.png';
import glacier_grenade from '../assets/Shared/Grenades/Stasis/glacier_grenade.png';
//fragments
import whisper_of_bonds from '../assets/Shared/Fragments/Stasis/whisper_of_bonds.png';
import whisper_of_chains from '../assets/Shared/Fragments/Stasis/whisper_of_chains.png';
import whisper_of_conduction from '../assets/Shared/Fragments/Stasis/whisper_of_conduction.png';
import whisper_of_durance from '../assets/Shared/Fragments/Stasis/whisper_of_durance.png';
import whisper_of_fissures from '../assets/Shared/Fragments/Stasis/whisper_of_fissures.png';
import whisper_of_fractures from '../assets/Shared/Fragments/Stasis/whisper_of_fractures.png';
import whisper_of_hedrons from '../assets/Shared/Fragments/Stasis/whisper_of_hedrons.png';
import whisper_of_hunger from '../assets/Shared/Fragments/Stasis/whisper_of_hunger.png';
import whisper_of_impetus from '../assets/Shared/Fragments/Stasis/whisper_of_impetus.png';
import whisper_of_refraction from '../assets/Shared/Fragments/Stasis/whisper_of_refraction.png';
import whisper_of_rending from '../assets/Shared/Fragments/Stasis/whisper_of_rending.png';
import whisper_of_rime from '../assets/Shared/Fragments/Stasis/whisper_of_rime.png';
import whisper_of_shards from '../assets/Shared/Fragments/Stasis/whisper_of_shards.png';
import whisper_of_torment from '../assets/Shared/Fragments/Stasis/whisper_of_torment.png';

//strand sharables
//grenades
import grapple_grenade from '../assets/Shared/Grenades/Strand/grapple_grenade.jpg';
import shackle_grenade from '../assets/Shared/Grenades/Strand/shackle_grenade.jpg';
import threadling_grenade from '../assets/Shared/Grenades/Strand/threadling_grenade.jpg';
//fragments
import thread_of_ascent from '../assets/Shared/Fragments/Strand/thread_of_ascent.jpg';
import thread_of_binding from '../assets/Shared/Fragments/Strand/thread_of_binding.jpg';
import thread_of_continuity from '../assets/Shared/Fragments/Strand/thread_of_continuity.jpg';
import thread_of_evolution from '../assets/Shared/Fragments/Strand/thread_of_evolution.jpg';
import thread_of_finality from '../assets/Shared/Fragments/Strand/thread_of_finality.jpg';
import thread_of_fury from '../assets/Shared/Fragments/Strand/thread_of_fury.jpg';
import thread_of_generation from '../assets/Shared/Fragments/Strand/thread_of_generation.jpg';
import thread_of_isolation from '../assets/Shared/Fragments/Strand/thread_of_isolation.jpg';
import thread_of_mind from '../assets/Shared/Fragments/Strand/thread_of_mind.jpg';
import thread_of_propagation from '../assets/Shared/Fragments/Strand/thread_of_propagation.jpg';
import thread_of_rebirth from '../assets/Shared/Fragments/Strand/thread_of_rebirth.jpg';
import thread_of_transmutation from '../assets/Shared/Fragments/Strand/thread_of_transmutation.jpg';
import thread_of_warding from '../assets/Shared/Fragments/Strand/thread_of_warding.jpg';
import thread_of_wisdom from '../assets/Shared/Fragments/Strand/thread_of_wisdom.jpg';

//warlock exclusives
//void
import nova_bomb_vortex from '../assets/Warlock/Void/nova_bomb_vortex.png'
import nova_bomb_cataclysm from '../assets/Warlock/Void/nova_bomb_cataclysm.png'
import nova_warp from '../assets/Warlock/Void/nova_warp.png'

import healing_rift_voi from '../assets/Warlock/Void/healing_rift.jpg'
import empowering_rift_voi from '../assets/Warlock/Void/empowering_rift.jpg'

import pocket_singularity from '../assets/Warlock/Void/pocket_singularity.jpg'

import chaos_accelerant from '../assets/Warlock/Void/chaos_accelerant.jpg'
import child_of_the_old_gods from '../assets/Warlock/Void/child_of_the_old_gods.jpg'
import feed_the_void from '../assets/Warlock/Void/feed_the_void.jpg'

//solar
import daybreak from '../assets/Warlock/Solar/daybreak.png'
import well_of_radiance from '../assets/Warlock/Solar/well_of_radiance.png'

import healing_rift_sol from '../assets/Warlock/Solar/healing_rift.jpg'
import empowering_rift_sol from '../assets/Warlock/Solar/empowering_rift.jpg'
import phoenix_dive from '../assets/Warlock/Solar/phoenix_dive.jpg'

import celestial_fire from '../assets/Warlock/Solar/celestial_fire.jpg'
import incinerator_snap from '../assets/Warlock/Solar/incinerator_snap.jpg'

import icarus_dash from '../assets/Warlock/Solar/icarus_dash.jpg'
import heat_rises from '../assets/Warlock/Solar/heat_rises.jpg'
import touch_of_flame from '../assets/Warlock/Solar/touch_of_flame.jpg'

//arc
import chaos_reach from '../assets/Warlock/Arc/chaos_reach.png'
import stormtrance from '../assets/Warlock/Arc/stormtrance.png'

import healing_rift_arc from '../assets/Warlock/Arc/healing_rift.jpg'
import empowering_rift_arc from '../assets/Warlock/Arc/empowering_rift.jpg'

import ball_lightning from '../assets/Warlock/Arc/ball_lightning.jpg'
import chain_lightning from '../assets/Warlock/Arc/chain_lightning.jpg'

import arc_soul from '../assets/Warlock/Arc/arc_soul.jpg'
import electrostatic_mind from '../assets/Warlock/Arc/electrostatic_mind.jpg'
import lightning_surge from '../assets/Warlock/Arc/lightning_surge.jpg'

//stasis
import winters_wrath from '../assets/Warlock/Stasis/winters_wrath.png'

import healing_rift_sta from '../assets/Warlock/Stasis/healing_rift.png'
import empowering_rift_sta from '../assets/Warlock/Stasis/empowering_rift.png'

import penumbral_blast from '../assets/Warlock/Stasis/penumbral_blast.png'

import bleak_watcher from '../assets/Warlock/Stasis/bleak_watcher.png'
import frostpulse from '../assets/Warlock/Stasis/frostpulse.png'
import glacial_harvest from '../assets/Warlock/Stasis/glacial_harvest.png'
import iceflare_bolts from '../assets/Warlock/Stasis/iceflare_bolts.png'


//strand
import needlestorm from '../assets/Warlock/Strand/needlestorm.png'

import healing_rift_str from '../assets/Warlock/Strand/healing_rift.png'
import empowering_rift_str from '../assets/Warlock/Strand/empowering_rift.png'

import arcane_needle from '../assets/Warlock/Strand/arcane_needle.png'

import mindspun_invocation from '../assets/Warlock/Strand/mindspun_invocation.jpg'
import weavers_call from '../assets/Warlock/Strand/weavers_call.jpg'

//hunter exclusives
//void
import shadowshot_deadfall from '../assets/Hunter/Void/shadowshot_deadfall.png'
import shadowshot_mobius_quiver from '../assets/Hunter/Void/shadowshot_mobius_quiver.png'
import spectral_blades from '../assets/Hunter/Void/spectral_blades.png'

import gamblers_dodge_voi from '../assets/Hunter/Void/gamblers_dodge.jpg'
import marksman_dodge_voi from '../assets/Hunter/Void/marksman_dodge.jpg'

import snare_bomb from '../assets/Hunter/Void/snare_bomb.jpg'

import stylish_executioner from '../assets/Hunter/Void/stylish_executioner.jpg'
import trappers_ambush from '../assets/Hunter/Void/trappers_ambush.jpg'
import vanishing_step from '../assets/Hunter/Void/vanishing_step.jpg'

//solar
import blade_barrage from '../assets/Hunter/Solar/blade_barrage.png'
import golden_gun_deadshot from '../assets/Hunter/Solar/golden_gun_deadshot.png'
import golden_gun_marksman from '../assets/Hunter/Solar/golden_gun_marksman.png'

import gamblers_dodge_sol from '../assets/Hunter/Solar/gamblers_dodge.jpg'
import marksman_dodge_sol from '../assets/Hunter/Solar/marksman_dodge.jpg'
import acrobat_dodge from '../assets/Hunter/Solar/acrobat_dodge.jpg'

import knife_trick from '../assets/Hunter/Solar/knife_trick.jpg'
import lightweight_knife from '../assets/Hunter/Solar/lightweight_knife.jpg'
import proximity_explosive_knife from '../assets/Hunter/Solar/proximity_explosive_knife.jpg'
import weighted_throwing_knife from '../assets/Hunter/Solar/weighted_throwing_knife.jpg'

import gunpowder_gamble from '../assets/Hunter/Solar/gunpowder_gamble.jpg'
import knock_em_down from '../assets/Hunter/Solar/knock_em_down.jpg'
import on_your_mark from '../assets/Hunter/Solar/on_your_mark.jpg'

//arc
import arc_staff from '../assets/Hunter/Arc/arc_staff.png'
import gathering_storm from '../assets/Hunter/Arc/gathering_storm.png'

import gamblers_dodge_arc from '../assets/Hunter/Arc/gamblers_dodge.jpg'
import marksman_dodge_arc from '../assets/Hunter/Arc/marksman_dodge.jpg'

import combination_blows from '../assets/Hunter/Arc/combination_blow.jpg'
import disorienting_blows from '../assets/Hunter/Arc/disorienting_blow.jpg'

import flow_state from '../assets/Hunter/Arc/flow_state.jpg'
import lethal_current from '../assets/Hunter/Arc/lethal_current.jpg'
import tempest_strike from '../assets/Hunter/Arc/tempest_strike.jpg'

//stasis
import silence_and_squall from '../assets/Hunter/Stasis/silence_and_squall.png'

import gamblers_dodge_sta from '../assets/Hunter/Stasis/gamblers_dodge.png'
import marksman_dodge_sta from '../assets/Hunter/Stasis/marksman_dodge.png'

import withering_blade from '../assets/Hunter/Stasis/withering_blade.png'

import grim_harvest from '../assets/Hunter/Stasis/grim_harvest.png'
import shatterdive from '../assets/Hunter/Stasis/shatterdive.png'
import touch_of_winter from '../assets/Hunter/Stasis/touch_of_winter.png'
import winters_shroud from '../assets/Hunter/Stasis/winters_shroud.png'

//strand
import silkstrike from '../assets/Hunter/Strand/silkstrike.png'

import gamblers_dodge_str from '../assets/Hunter/Strand/gamblers_dodge.png'
import marksman_dodge_str from '../assets/Hunter/Strand/marksman_dodge.png'

import threaded_spike from '../assets/Hunter/Strand/threaded_spike.png'

import ensearing_slam from '../assets/Hunter/Strand/ensearing_slam.jpg'
import widows_silk from '../assets/Hunter/Strand/widows_silk.jpg'


//titan exclusives
//void
import sentinel_shield from '../assets/Titan/Void/sentinel_shield.png'
import ward_of_dawn from '../assets/Titan/Void/ward_of_dawn.png'

import rally_barricade_voi from '../assets/Titan/Void/rally_barricade.jpg'
import towering_barricade_voi from '../assets/Titan/Void/towering_barricade.jpg'

import shield_bash from '../assets/Titan/Void/shield_bash.jpg'
import shield_throw from '../assets/Titan/Void/shield_throw.jpg'

import bastion from '../assets/Titan/Void/bastion.jpg'
import controlled_demolition from '../assets/Titan/Void/controlled_demolition.jpg'
import offensive_bulwark from '../assets/Titan/Void/offensive_bulwark.jpg'

//solar
import burning_maul from '../assets/Titan/Solar/burning_maul.png'
import hammer_of_sol from '../assets/Titan/Solar/hammer_of_sol.png'

import rally_barricade_sol from '../assets/Titan/Solar/rally_barricade.jpg'
import towering_barricade_sol from '../assets/Titan/Solar/towering_barricade.jpg'

import hammer_strike from '../assets/Titan/Solar/hammer_strike.jpg'
import throwing_hammer from '../assets/Titan/Solar/throwing_hammer.jpg'

import consecration from '../assets/Titan/Solar/consecration.jpg'
import roaring_flames from '../assets/Titan/Solar/roaring_flames.jpg'
import sol_invictus from '../assets/Titan/Solar/sol_invictus.jpg'

//arc
import fists_of_havoc from '../assets/Titan/Arc/fists_of_havoc.png'
import thundercrash from '../assets/Titan/Arc/thundercrash.png'

import rally_barricade_arc from '../assets/Titan/Arc/rally_barricade.jpg'
import towering_barricade_arc from '../assets/Titan/Arc/towering_barricade.jpg'
import thruster from '../assets/Titan/Arc/thruster.jpg'

import ballistic_slam from '../assets/Titan/Arc/ballistic_slam.jpg'
import seismic_strike from '../assets/Titan/Arc/seismic_strike.jpg'
import thunderclap from '../assets/Titan/Arc/thunderclap.jpg'

import juggernaut from '../assets/Titan/Arc/juggernaut.jpg'
import knockout from '../assets/Titan/Arc/knockout.jpg'
import touch_of_thunder from '../assets/Titan/Arc/touch_of_thunder.jpg'

//stasis
import glacial_quake from '../assets/Titan/Stasis/glacial_quake.png'

import rally_barricade_sta from '../assets/Titan/Stasis/rally_barricade.png'
import towering_barricade_sta from '../assets/Titan/Stasis/towering_barricade.png'

import shiver_strike from '../assets/Titan/Stasis/shiver_strike.png'

import cryoclasm from '../assets/Titan/Stasis/cryoclasm.png'
import diamond_lance from '../assets/Titan/Stasis/diamond_lance.png'
import howl_of_the_storm from '../assets/Titan/Stasis/howl_of_the_storm.png'
import tectonic_harvest from '../assets/Titan/Stasis/tectonic_harvest.png'

//strand
import bladefury from '../assets/Titan/Strand/bladefury.png'

import rally_barricade_str from '../assets/Titan/Strand/rally_barricade.png'
import towering_barricade_str from '../assets/Titan/Strand/towering_barricade.png'

import frenzied_blade from '../assets/Titan/Strand/frenzied_blade.png'

import drengrs_lash from '../assets/Titan/Strand/drengrs_lash.jpg'
import into_the_fray from '../assets/Titan/Strand/into_the_fray.jpg'

//weapons
import ace_of_spades from '../assets/Weapons/ace_of_spades.jpg'
import agers_scepter from '../assets/Weapons/agers_scepter.jpg'
import anarchy from '../assets/Weapons/anarchy.jpg'
import arbalest from '../assets/Weapons/arbalest.jpg'
import bad_juju from '../assets/Weapons/bad_juju.jpg'
import bastion_wea from '../assets/Weapons/bastion.jpg'
import black_talon from '../assets/Weapons/black_talon.jpg'
import borealis from '../assets/Weapons/borealis.jpg'
import cerberus_plus1 from '../assets/Weapons/cerberus_plus1.jpg'
import cloudstrike from '../assets/Weapons/cloudstrike.jpg'

import coldheart from '../assets/Weapons/coldheart.jpg'
import collective_obligation from '../assets/Weapons/collective_obligation.jpg'
import conditional_finality from '../assets/Weapons/conditional_finality.jpg'
import crimson from '../assets/Weapons/crimson.jpg'
import cryothesisa_77k from '../assets/Weapons/cryothesisa_77k.jpg'
import darci from '../assets/Weapons/darci.jpg'
import dead_mans_tale from '../assets/Weapons/dead_mans_tale.jpg'
import dead_messenger from '../assets/Weapons/dead_messenger.jpg'
import deathbringer from '../assets/Weapons/deathbringer.jpg'
import delicate_tomb from '../assets/Weapons/delicate_tomb.jpg'

import deterministic_chaos from '../assets/Weapons/deterministic_chaos.jpg'
import devils_ruin from '../assets/Weapons/devils_ruin.jpg'
import divinity from '../assets/Weapons/divinity.jpg'
import duality from '../assets/Weapons/duality.jpg'
import edge_of_action from '../assets/Weapons/edge_of_action.jpg'
import edge_of_concurrance from '../assets/Weapons/edge_of_concurrance.jpg'
import edge_of_intent from '../assets/Weapons/edge_of_intent.jpg'
import erianas_vow from '../assets/Weapons/erianas_vow.jpg'
import eyes_of_tomorrow from '../assets/Weapons/eyes_of_tomorrow.jpg'
import fighting_lion from '../assets/Weapons/fighting_lion.jpg'

import final_warning from '../assets/Weapons/final_warning.jpg'
import forerunner from '../assets/Weapons/forerunner.jpg'
import gjallarhorn from '../assets/Weapons/gjallarhorn.jpg'
import grand_overture from '../assets/Weapons/grand_overture.jpg'
import graviton_lance from '../assets/Weapons/graviton_lance.jpg'
import hard_light from '../assets/Weapons/hard_light.jpg'
import hawkmoon from '../assets/Weapons/hawkmoon.jpg'
import heartshadow from '../assets/Weapons/heartshadow.jpg'
import heir_apparent from '../assets/Weapons/heir_apparent.jpg'
import hierarchy_of_needs from '../assets/Weapons/hierarchy_of_needs.jpg'

import izanagis_burden from '../assets/Weapons/izanagis_burden.jpg'
import jotunn from '../assets/Weapons/jotunn.jpg'
import le_monarque from '../assets/Weapons/le_monarque.jpg'
import legend_of_acrius from '../assets/Weapons/legend_of_acrius.jpg'
import leviathans_breath from '../assets/Weapons/leviathans_breath.jpg'
import lord_of_wolves from '../assets/Weapons/lord_of_wolves.jpg'
import lorentz_driver from '../assets/Weapons/lorentz_driver.jpg'
import lumina from '../assets/Weapons/lumina.jpg'
import malfeasance from '../assets/Weapons/malfeasance.jpg'
import merciless from '../assets/Weapons/merciless.jpg'

import mida_multi_tool from '../assets/Weapons/mida_multi_tool.jpg'
import monte_carlo from '../assets/Weapons/monte_carlo.jpg'
import no_time_to_explain from '../assets/Weapons/no_time_to_explain.jpg'
import one_thousand_voices from '../assets/Weapons/one_thousand_voices.jpg'
import osteo_striga from '../assets/Weapons/osteo_striga.jpg'
import outbreak_perfected from '../assets/Weapons/outbreak_perfected.jpg'
import parasite from '../assets/Weapons/parasite.jpg'
import polaris_lance from '../assets/Weapons/polaris_lance.jpg'
import prometheus_lens from '../assets/Weapons/prometheus_lens.jpg'
import quicksilver_storm from '../assets/Weapons/quicksilver_storm.jpg'

import rat_king from '../assets/Weapons/rat_king.jpg'
import revision_zero from '../assets/Weapons/revision_zero.jpg'
import riskrunner from '../assets/Weapons/riskrunner.jpg'
import ruinous_effigy from '../assets/Weapons/ruinous_effigy.jpg'
import salvations_grip from '../assets/Weapons/salvations_grip.jpg'
import skyburners_oath from '../assets/Weapons/skyburners_oath.jpg'
import sleeper_simulant from '../assets/Weapons/sleeper_simulant.jpg'
import sturm from '../assets/Weapons/sturm.jpg'
import sunshot from '../assets/Weapons/sunshot.jpg'
import suros_regime from '../assets/Weapons/suros_regime.jpg'

import sweet_business from '../assets/Weapons/sweet_business.jpg'
import symmetry from '../assets/Weapons/symmetry.jpg'
import tarrabah from '../assets/Weapons/tarrabah.jpg'
import telesto from '../assets/Weapons/telesto.jpg'
import the_chaperone from '../assets/Weapons/the_chaperone.jpg'
import the_colony from '../assets/Weapons/the_colony.jpg'
import the_fourth_horseman from '../assets/Weapons/the_fourth_horseman.jpg'
import the_huckleberry from '../assets/Weapons/the_huckleberry.jpg'
import the_jade_rabbit from '../assets/Weapons/the_jade_rabbit.jpg'
import the_lament from '../assets/Weapons/the_lament.jpg'

import the_last_word from '../assets/Weapons/the_last_word.jpg'
import the_manticore from '../assets/Weapons/the_manticore.jpg'
import the_prospector from '../assets/Weapons/the_prospector.jpg'
import the_queenbreaker from '../assets/Weapons/the_queenbreaker.jpg'
import the_wardcliff_coil from '../assets/Weapons/the_wardcliff_coil.jpg'
import thorn from '../assets/Weapons/thorn.jpg'
import thunderlord from '../assets/Weapons/thunderlord.jpg'
import ticuus_divination from '../assets/Weapons/ticuus_divination.jpg'
import tommys_matchbook from '../assets/Weapons/tommys_matchbook.jpg'
import touch_of_malice from '../assets/Weapons/touch_of_malice.jpg'

import tractor_cannon from '../assets/Weapons/tractor_cannon.jpg'
import travelers_chosen from '../assets/Weapons/travelers_chosen.jpg'
import trespasser from '../assets/Weapons/trespasser.jpg'
import trinity_ghoul from '../assets/Weapons/trinity_ghoul.jpg'
import truth from '../assets/Weapons/truth.jpg'
import two_tailed_fox from '../assets/Weapons/two_tailed_fox.jpg'
import verglas_curve from '../assets/Weapons/verglas_curve.jpg'
import vex_mythoclast from '../assets/Weapons/vex_mythoclast.jpg'
import vexcalibur from '../assets/Weapons/vexcalibur.jpg'
import vigilance_wing from '../assets/Weapons/vigilance_wing.jpg'

import wavesplitter from '../assets/Weapons/wavesplitter.jpg'
import whisper_of_the_worm from '../assets/Weapons/whisper_of_the_worm.jpg'
import winterbite from '../assets/Weapons/winterbite.jpg'
import wish_ender from '../assets/Weapons/wish_ender.jpg'
import witherhoard from '../assets/Weapons/witherhoard.jpg'
import worldline_zero from '../assets/Weapons/worldline_zero.jpg'
import xenophage from '../assets/Weapons/xenophage.jpg'

//Armor
//hunter

import aeon_swift from '../assets/Armor/Hunter/aeon_swift.jpg'
import assassins_cowl from '../assets/Armor/Hunter/assassins_cowl.jpg'
import athryss_embrace from '../assets/Armor/Hunter/athryss_embrace.jpg'
import blight_ranger from '../assets/Armor/Hunter/blight_ranger.jpg'
import calibans_hand from '../assets/Armor/Hunter/calibans_hand.jpg'
import celestial_nighthawk from '../assets/Armor/Hunter/celestial_nighthawk.jpg'
import cyrtarachnes_facade from '../assets/Armor/Hunter/cyrtarachnes_facade.jpg'
import foetracer from '../assets/Armor/Hunter/foetracer.jpg'
import fr0st_ee5 from '../assets/Armor/Hunter/fr0st_ee5.jpg'
import gemini_jester from '../assets/Armor/Hunter/gemini_jester.jpg'

import graviton_forfeit from '../assets/Armor/Hunter/graviton_forfeit.jpg'
import gwisin_vest from '../assets/Armor/Hunter/gwisin_vest.jpg'
import gyrfalcons_hauberk from '../assets/Armor/Hunter/gyrfalcons_hauberk.jpg'
import khepris_sting from '../assets/Armor/Hunter/khepris_sting.jpg'
import knucklehead_radar from '../assets/Armor/Hunter/knucklehead_radar.jpg'
import liars_handshake from '../assets/Armor/Hunter/liars_handshake.jpg'
import lucky_pants from '../assets/Armor/Hunter/lucky_pants.jpg'
import lucky_raspberry from '../assets/Armor/Hunter/lucky_raspberry.jpg'
import mask_of_bakris from '../assets/Armor/Hunter/mask_of_bakris.jpg'
import mechaneers_tricksleeves from '../assets/Armor/Hunter/mechaneers_tricksleeves.jpg'

import oathkeeper from '../assets/Armor/Hunter/oathkeeper.jpg'
import omnioculus from '../assets/Armor/Hunter/omnioculus.jpg'
import ophidia_spathe from '../assets/Armor/Hunter/ophidia_spathe.jpg'
import orpheus_rig from '../assets/Armor/Hunter/orpheus_rig.jpg'
import radiant_dance_machines from '../assets/Armor/Hunter/radiant_dance_machines.jpg'
import raiden_flux from '../assets/Armor/Hunter/raiden_flux.jpg'
import raijus_harness from '../assets/Armor/Hunter/raijus_harness.jpg'
import renewal_grasps from '../assets/Armor/Hunter/renewal_grasps.jpg'
import sealed_ahamkara_grasps from '../assets/Armor/Hunter/sealed_ahamkara_grasps.jpg'
import shards_of_galanor from '../assets/Armor/Hunter/shards_of_galanor.jpg'

import shinobus_vow from '../assets/Armor/Hunter/shinobus_vow.jpg'
import speedloader_slacks from '../assets/Armor/Hunter/speedloader_slacks.jpg'
import st0mp_ee5 from '../assets/Armor/Hunter/st0mp_ee5.jpg'
import star_eater_scales from '../assets/Armor/Hunter/star_eater_scales.jpg'
import the_bombardiers from '../assets/Armor/Hunter/the_bombardiers.jpg'
import the_dragons_shadow from '../assets/Armor/Hunter/the_dragons_shadow.jpg'
import the_sixth_coyote from '../assets/Armor/Hunter/the_sixth_coyote.jpg'
import wormhusk_crown from '../assets/Armor/Hunter/wormhusk_crown.jpg'
import young_ahamkaras_spine from '../assets/Armor/Hunter/young_ahamkaras_spine.jpg'


//titan
import abeyant_leap from '../assets/Armor/Titan/abeyant_leap.jpg'
import acd0_feedback_fence from '../assets/Armor/Titan/acd0_feedback_fence.jpg'
import actium_war_rig from '../assets/Armor/Titan/actium_war_rig.jpg'
import aeon_safe from '../assets/Armor/Titan/aeon_safe.jpg'
import an_insurmountable_skullfort from '../assets/Armor/Titan/an_insurmountable_skullfort.jpg'
import antaeus_wards from '../assets/Armor/Titan/antaeus_wards.jpg'
import armamentarium from '../assets/Armor/Titan/armamentarium.jpg'
import ashen_wake from '../assets/Armor/Titan/ashen_wake.jpg'
import cadmus_ridge_lancecap from '../assets/Armor/Titan/cadmus_ridge_lancecap.jpg'
import citans_ramparts from '../assets/Armor/Titan/citans_ramparts.jpg'

import crest_of_alpha_lupi from '../assets/Armor/Titan/crest_of_alpha_lupi.jpg'
import doom_fang_pauldron from '../assets/Armor/Titan/doom_fang_pauldron.jpg'
import dunemarchers from '../assets/Armor/Titan/dunemarchers.jpg'
import eternal_warrior from '../assets/Armor/Titan/eternal_warrior.jpg'
import hallowfire_heart from '../assets/Armor/Titan/hallowfire_heart.jpg'
import heart_of_inmost_light from '../assets/Armor/Titan/heart_of_inmost_light.jpg'
import helm_of_saint14 from '../assets/Armor/Titan/helm_of_saint14.jpg'
import hoarfrost_z from '../assets/Armor/Titan/hoarfrost_z.jpg'
import icefall_mantle from '../assets/Armor/Titan/icefall_mantle.jpg'
import khepris_horn from '../assets/Armor/Titan/khepris_horn.jpg'

import lion_rampant from '../assets/Armor/Titan/lion_rampant.jpg'
import loreley_splendor_helm from '../assets/Armor/Titan/loreley_splendor_helm.jpg'
import mask_of_the_quiet_one from '../assets/Armor/Titan/mask_of_the_quiet_one.jpg'
import mk44_stand_asides from '../assets/Armor/Titan/mk44_stand_asides.jpg'
import no_backup_plans from '../assets/Armor/Titan/no_backup_plans.jpg'
import one_eyed_mask from '../assets/Armor/Titan/one_eyed_mask.jpg'
import peacekeepers from '../assets/Armor/Titan/peacekeepers.jpg'
import peregrine_greaves from '../assets/Armor/Titan/peregrine_greaves.jpg'
import phoenix_cradle from '../assets/Armor/Titan/phoenix_cradle.jpg'
import point_cannon_contact_brace from '../assets/Armor/Titan/point_cannon_contact_brace.jpg'

import precious_scars from '../assets/Armor/Titan/precious_scars.jpg'
import second_chance from '../assets/Armor/Titan/second_chance.jpg'
import severance_enclosure from '../assets/Armor/Titan/severance_enclosure.jpg'
import stronghold from '../assets/Armor/Titan/stronghold.jpg'
import synthoceps from '../assets/Armor/Titan/synthoceps.jpg'
import the_path_of_burning_steps from '../assets/Armor/Titan/the_path_of_burning_steps.jpg'
import ursa_furiosa from '../assets/Armor/Titan/ursa_furiosa.jpg'
import wormgod_caress from '../assets/Armor/Titan/wormgod_caress.jpg'
import cuirass_of_the_falling_star from '../assets/Armor/Titan/cuirass_of_the_falling_star.jpg'

//warlock
import aeon_soul from '../assets/Armor/Warlock/aeon_soul.jpg'
import apotheosis_veil from '../assets/Armor/Warlock/apotheosis_veil.jpg'
import astrocyte_verse from '../assets/Armor/Warlock/astrocyte_verse.jpg'
import ballidorse_wrathweavers from '../assets/Armor/Warlock/ballidorse_wrathweavers.jpg'
import boots_of_the_assembler from '../assets/Armor/Warlock/boots_of_the_assembler.jpg'
import chromatic_fire from '../assets/Armor/Warlock/chromatic_fire.jpg'
import claws_of_ahamkara from '../assets/Armor/Warlock/claws_of_ahamkara.jpg'
import contraverse_hold from '../assets/Armor/Warlock/contraverse_hold.jpg'
import crown_of_tempests from '../assets/Armor/Warlock/crown_of_tempests.jpg'
import dawn_chorus from '../assets/Armor/Warlock/dawn_chorus.jpg'

import eye_of_another_world from '../assets/Armor/Warlock/eye_of_another_world.jpg'
import fallen_sunstar from '../assets/Armor/Warlock/fallen_sunstar.jpg'
import felwinters_helm from '../assets/Armor/Warlock/felwinters_helm.jpg'
import geomag_stablizers from '../assets/Armor/Warlock/geomag_stablizers.jpg'
import getaway_artist from '../assets/Armor/Warlock/getaway_artist.jpg'
import karnstein_armlets from '../assets/Armor/Warlock/karnstein_armlets.jpg'
import lunafaction_boots from '../assets/Armor/Warlock/lunafaction_boots.jpg'
import mantle_of_battle_harmony from '../assets/Armor/Warlock/mantle_of_battle_harmony.jpg'
import necrotic_grip from '../assets/Armor/Warlock/necrotic_grip.jpg'
import nezarecs_sin from '../assets/Armor/Warlock/nezarecs_sin.jpg'

import nothing_manacles from '../assets/Armor/Warlock/nothing_manacles.jpg'
import ophidian_aspect from '../assets/Armor/Warlock/ophidian_aspect.jpg'
import osmiomancy_gloves from '../assets/Armor/Warlock/osmiomancy_gloves.jpg'
import phoenix_protocol from '../assets/Armor/Warlock/phoenix_protocol.jpg'
import promethium_spur from '../assets/Armor/Warlock/promethium_spur.jpg'
import rain_of_fire from '../assets/Armor/Warlock/rain_of_fire.jpg'
import sanguine_alchemy from '../assets/Armor/Warlock/sanguine_alchemy.jpg'
import secant_filaments from '../assets/Armor/Warlock/secant_filaments.jpg'
import skull_of_dire_ahamkara from '../assets/Armor/Warlock/skull_of_dire_ahamkara.jpg'
import starfire_protocol from '../assets/Armor/Warlock/starfire_protocol.jpg'

import stormdancers_brace from '../assets/Armor/Warlock/stormdancers_brace.jpg'
import sunbracers from '../assets/Armor/Warlock/sunbracers.jpg'
import swarmers from '../assets/Armor/Warlock/swarmers.jpg'
import the_stag from '../assets/Armor/Warlock/the_stag.jpg'
import transversive_steps from '../assets/Armor/Warlock/transversive_steps.jpg'
import veritys_brow from '../assets/Armor/Warlock/veritys_brow.jpg'
import vesper_of_radius from '../assets/Armor/Warlock/vesper_of_radius.jpg'
import wings_of_sacred_dawn from '../assets/Armor/Warlock/wings_of_sacred_dawn.jpg'
import winters_guile from '../assets/Armor/Warlock/winters_guile.jpg'

const images = {
    none,
    bg,
    armor,
    weapons,
    login,
    play,
    reroll,
    home,
    title,
    logout,

    selall,
    deselall,
    confirm,

    register,

    //subclasses
    arc,
    grape,
    solar,
    stasis,
    strand,

    //classes
    hunter,
    warlock,
    titan,

    //void grenades
    magnetic_grenade,
    axion_bolt_grenade,
    scatter_grenade,
    suppressor_grenade,
    void_spike_grenade,
    void_wall_grenade,
    vortex_grenade,

    //void fragments
    echo_of_cessation,
    echo_of_dialation,
    echo_of_domineering,
    echo_of_exchange,
    echo_of_expulsion,
    echo_of_harvest,
    echo_of_instability,
    echo_of_leeching,
    echo_of_obscurity,
    echo_of_persistance,
    echo_of_provision,
    echo_of_remnants,
    echo_of_reprisal,
    echo_of_starvation,
    echo_of_undermining,
    echo_of_vigilance,

    //solar grenades
    firebolt_grenade,
    fusion_grenade,
    healing_grenade,
    incindiary_grenade,
    solar_grenade,
    swarm_grenade,
    thermite_grenade,
    tripmine_grenade,

    //solar fragments
    ember_of_ashes,
    ember_of_beams,
    ember_of_benevolence,
    ember_of_blistering,
    ember_of_char,
    ember_of_combustion,
    ember_of_empyrian,
    ember_of_eruption,
    ember_of_mercy,
    ember_of_resolve,
    ember_of_searing,
    ember_of_singeing,
    ember_of_solace,
    ember_of_tempering,
    ember_of_torches,
    ember_of_wonder,

    //arc grenades
    arcbolt_grenade,
    flashbang_grenade,
    flux_grenade,
    lightning_grenade,
    pulse_grenade,
    skip_grenade,
    storm_grenade,

    //arc fragments
    spark_of_amplitude,
    spark_of_beacons,
    spark_of_brilliance,
    spark_of_discharge,
    spark_of_feedback,
    spark_of_focus,
    spark_of_frequency,
    spark_of_haste,
    spark_of_instinct,
    spark_of_ions,
    spark_of_magnitude,
    spark_of_momentum,
    spark_of_recharge,
    spark_of_resistance,
    spark_of_shock,
    spark_of_volts,

    //stasis grenades
    coldsnap_grenade,
    duskfield_grenade,
    glacier_grenade,

    //stasis fragments
    whisper_of_bonds,
    whisper_of_chains,
    whisper_of_conduction,
    whisper_of_durance,
    whisper_of_fissures,
    whisper_of_fractures,
    whisper_of_hedrons,
    whisper_of_hunger,
    whisper_of_impetus,
    whisper_of_refraction,
    whisper_of_rending,
    whisper_of_rime,
    whisper_of_shards,
    whisper_of_torment,

    //strand grenades
    grapple_grenade,
    shackle_grenade,
    threadling_grenade,

    //strand fragments
    thread_of_ascent,
    thread_of_binding,
    thread_of_continuity,
    thread_of_evolution,
    thread_of_finality,
    thread_of_fury,
    thread_of_generation,
    thread_of_isolation,
    thread_of_mind,
    thread_of_propagation,
    thread_of_rebirth,
    thread_of_transmutation,
    thread_of_warding,
    thread_of_wisdom,

    //warlock exclusives
    //void
    nova_bomb_vortex,
    nova_bomb_cataclysm,
    nova_warp,

    healing_rift_voi,
    empowering_rift_voi,

    pocket_singularity,

    chaos_accelerant,
    child_of_the_old_gods,
    feed_the_void,

    //solar
    daybreak,
    well_of_radiance,

    healing_rift_sol,
    empowering_rift_sol,
    phoenix_dive,

    celestial_fire,
    incinerator_snap,

    icarus_dash,
    heat_rises,
    touch_of_flame,

    //arc
    chaos_reach,
    stormtrance,

    healing_rift_arc,
    empowering_rift_arc,

    ball_lightning,
    chain_lightning,

    arc_soul,
    electrostatic_mind,
    lightning_surge,

    //stasis
    winters_wrath,

    healing_rift_sta,
    empowering_rift_sta,

    penumbral_blast,

    bleak_watcher,
    frostpulse,
    glacial_harvest,
    iceflare_bolts,

    //strand
    needlestorm,

    healing_rift_str,
    empowering_rift_str,

    arcane_needle,

    mindspun_invocation,
    weavers_call,

    //hunter exclusives
    //void
    shadowshot_deadfall,
    shadowshot_mobius_quiver,
    spectral_blades,

    gamblers_dodge_voi,
    marksman_dodge_voi,

    snare_bomb,

    stylish_executioner,
    trappers_ambush,
    vanishing_step,

    //solar
    blade_barrage,
    golden_gun_deadshot,
    golden_gun_marksman,

    gamblers_dodge_sol,
    marksman_dodge_sol,
    acrobat_dodge,

    knife_trick,
    lightweight_knife,
    proximity_explosive_knife,
    weighted_throwing_knife,

    gunpowder_gamble,
    knock_em_down,
    on_your_mark,

    //arc
    arc_staff,
    gathering_storm,

    gamblers_dodge_arc,
    marksman_dodge_arc,

    combination_blows,
    disorienting_blows,

    flow_state,
    lethal_current,
    tempest_strike,

    //stasis
    silence_and_squall,

    gamblers_dodge_sta,
    marksman_dodge_sta,

    withering_blade,

    grim_harvest,
    shatterdive,
    touch_of_winter,
    winters_shroud,

    //strand
    silkstrike,

    gamblers_dodge_str,
    marksman_dodge_str,

    threaded_spike,

    ensearing_slam,
    widows_silk,
    //titan exclusives
    //void
    sentinel_shield,
    ward_of_dawn,

    rally_barricade_voi,
    towering_barricade_voi,

    shield_bash,
    shield_throw,

    bastion,
    controlled_demolition,
    offensive_bulwark,

    //solar
    burning_maul,
    hammer_of_sol,

    rally_barricade_sol,
    towering_barricade_sol,

    hammer_strike,
    throwing_hammer,

    consecration,
    roaring_flames,
    sol_invictus,

    //arc
    fists_of_havoc,
    thundercrash,

    rally_barricade_arc,
    towering_barricade_arc,
    thruster,

    ballistic_slam,
    seismic_strike,
    thunderclap,

    juggernaut,
    knockout,
    touch_of_thunder,

    //stasis
    glacial_quake,

    rally_barricade_sta,
    towering_barricade_sta,

    shiver_strike,

    cryoclasm,
    diamond_lance,
    howl_of_the_storm,
    tectonic_harvest,

    //strand
    bladefury,

    rally_barricade_str,
    towering_barricade_str,

    frenzied_blade,

    drengrs_lash,
    into_the_fray,

    //weapons
    ace_of_spades,
    agers_scepter,
    anarchy,
    arbalest,
    bad_juju,
    bastion_wea,
    black_talon,
    borealis,
    cerberus_plus1,
    cloudstrike,

    coldheart,
    collective_obligation,
    conditional_finality,
    crimson,
    cryothesisa_77k,
    darci,
    dead_mans_tale,
    dead_messenger,
    deathbringer,
    delicate_tomb,

    deterministic_chaos,
    devils_ruin,
    divinity,
    duality,
    edge_of_action,
    edge_of_concurrance,
    edge_of_intent,
    erianas_vow,
    eyes_of_tomorrow,
    fighting_lion,

    final_warning,
    forerunner,
    gjallarhorn,
    grand_overture,
    graviton_lance,
    hard_light,
    hawkmoon,
    heartshadow,
    heir_apparent,
    hierarchy_of_needs,

    izanagis_burden,
    jotunn,
    le_monarque,
    legend_of_acrius,
    leviathans_breath,
    lord_of_wolves,
    lorentz_driver,
    lumina,
    malfeasance,
    merciless,

    mida_multi_tool,
    monte_carlo,
    no_time_to_explain,
    one_thousand_voices,
    osteo_striga,
    outbreak_perfected,
    parasite,
    polaris_lance,
    prometheus_lens,
    quicksilver_storm,

    rat_king,
    revision_zero,
    riskrunner,
    ruinous_effigy,
    salvations_grip,
    skyburners_oath,
    sleeper_simulant,
    sturm,
    sunshot,
    suros_regime,

    sweet_business,
    symmetry,
    tarrabah,
    telesto,
    the_chaperone,
    the_colony,
    the_fourth_horseman,
    the_huckleberry,
    the_jade_rabbit,
    the_lament,

    the_last_word,
    the_manticore,
    the_prospector,
    the_queenbreaker,
    the_wardcliff_coil,
    thorn,
    thunderlord,
    ticuus_divination,
    tommys_matchbook,
    touch_of_malice,

    tractor_cannon,
    travelers_chosen,
    trespasser,
    trinity_ghoul,
    truth,
    two_tailed_fox,
    verglas_curve,
    vex_mythoclast,
    vexcalibur,
    vigilance_wing,

    wavesplitter,
    whisper_of_the_worm,
    winterbite,
    wish_ender,
    witherhoard,
    worldline_zero,
    xenophage,

    //armor
    //hunter

    aeon_swift,
    assassins_cowl,
    athryss_embrace,
    blight_ranger,
    calibans_hand,
    celestial_nighthawk,
    cyrtarachnes_facade,
    foetracer,
    fr0st_ee5,
    gemini_jester,
    graviton_forfeit,
    gwisin_vest,
    gyrfalcons_hauberk,
    khepris_sting,
    knucklehead_radar,
    liars_handshake,
    lucky_pants,
    lucky_raspberry,
    mask_of_bakris,
    mechaneers_tricksleeves,
    oathkeeper,
    omnioculus,
    ophidia_spathe,
    orpheus_rig,
    radiant_dance_machines,
    raiden_flux,
    raijus_harness,
    renewal_grasps,
    sealed_ahamkara_grasps,
    shards_of_galanor,
    shinobus_vow,
    speedloader_slacks,
    st0mp_ee5,
    star_eater_scales,
    the_bombardiers,
    the_dragons_shadow,
    the_sixth_coyote,
    wormhusk_crown,
    young_ahamkaras_spine,

    //titan
    abeyant_leap,
    acd0_feedback_fence,
    actium_war_rig,
    aeon_safe,
    an_insurmountable_skullfort,
    antaeus_wards,
    armamentarium,
    ashen_wake,
    cadmus_ridge_lancecap,
    citans_ramparts,
    crest_of_alpha_lupi,
    cuirass_of_the_falling_star,
    doom_fang_pauldron,
    dunemarchers,
    eternal_warrior,
    hallowfire_heart,
    heart_of_inmost_light,
    helm_of_saint14,
    hoarfrost_z,
    icefall_mantle,
    khepris_horn,
    lion_rampant,
    loreley_splendor_helm,
    mask_of_the_quiet_one,
    mk44_stand_asides,
    no_backup_plans,
    one_eyed_mask,
    peacekeepers,
    peregrine_greaves,
    phoenix_cradle,
    point_cannon_contact_brace,
    precious_scars,
    second_chance,
    severance_enclosure,
    stronghold,
    synthoceps,
    the_path_of_burning_steps,
    ursa_furiosa,
    wormgod_caress,

    //warlock
    aeon_soul,
    apotheosis_veil,
    astrocyte_verse,
    ballidorse_wrathweavers,
    boots_of_the_assembler,
    chromatic_fire,
    claws_of_ahamkara,
    contraverse_hold,
    crown_of_tempests,
    dawn_chorus,
    eye_of_another_world,
    fallen_sunstar,
    felwinters_helm,
    geomag_stablizers,
    getaway_artist,
    karnstein_armlets,
    lunafaction_boots,
    mantle_of_battle_harmony,
    necrotic_grip,
    nezarecs_sin,
    nothing_manacles,
    ophidian_aspect,
    osmiomancy_gloves,
    phoenix_protocol,
    promethium_spur,
    rain_of_fire,
    sanguine_alchemy,
    secant_filaments,
    skull_of_dire_ahamkara,
    starfire_protocol,
    stormdancers_brace,
    sunbracers,
    swarmers,
    the_stag,
    transversive_steps,
    veritys_brow,
    vesper_of_radius,
    wings_of_sacred_dawn,
    winters_guile
}

export default images;